export default {
  namespaced: true,
  state: () => ({
    status: 0
  }),
  getters: {
    status: state => state.status
  },
  mutations: {
    status (state, status) {
      state.status = Math.max(0, state.status + (status ? 1 : -1))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/LoadStatus.js